const VERIFICATION_BYPASS_PARAM = 'bypass_verification';

// The only value the backend honours - see shared/SyntheticBypass.kt's BYPASS_PARAM. Any other
// value is still forwarded so the backend stays the single authority on rejecting it.
const VERIFICATION_BYPASS_VALUE = 'tribe';

function getVerificationBypass(
  search: string = globalThis.location.search
): string {
  return new URLSearchParams(search).get(VERIFICATION_BYPASS_PARAM) ?? '';
}

/**
 * Whether the bypass the page was loaded with is one the backend will actually accept. Deliberately
 * stricter than "the param is present": skipping reCAPTCHA for a value the backend rejects would
 * send no token and earn a 401 instead of a bypass.
 */
function hasValidVerificationBypass(
  search: string = globalThis.location.search
): boolean {
  return getVerificationBypass(search) === VERIFICATION_BYPASS_VALUE;
}

export { getVerificationBypass, hasValidVerificationBypass };
